const Paths = {
  CLIMATE_TABLE_DATA: "/api/v1/climate-table-data",
  CLIMATE_SERIES_DATA: "/api/v1/climate-series-data",
  CLIMATE_MAP_STATIONS: "/api/v1/stations",
  CLIMATE_DOWNLOADS: "/api/v1/downloads",
};

export default Paths;
